import { keyframes } from "@emotion/react";
import type { ActivePhase } from "./useActivePhase";

export const fadeSlideUp = keyframes`
  0%   { opacity: 0; transform: translateY(48px); }
  100% { opacity: 1; transform: translateY(0); }
`;

export const fadeSlideDownOut = keyframes`
  0%   { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(48px); }
`;

export const animationFor = (phase: ActivePhase) => {
  switch (phase) {
    case "entering":
      return `${fadeSlideUp} 1000ms cubic-bezier(.2,.8,.3,1) both`;
    case "leaving":
      return `${fadeSlideDownOut} 1000ms cubic-bezier(.4,0,.6,1) both`;
    default:
      return undefined;
  }
};
